import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { TextEllipsis } from "../../../../../ui/components/text-ellipsis";
import { styledMedia } from "../../../../components/mediaquery/breakpoints";
import { Translation } from "../../../../core/translate";
import { ocean, magic } from "@vitalsource/vstui/colors";
import { actions as uiLibraryActions } from "../../../../../redux/ui/library";
import OpenFeaturedBookButton from "../open-featured-book-button";
import BookButton from "./book-button";

const Styled = {
  Container: styled.div`
    align-items: center;
    background-image: linear-gradient(
      90deg,
      ${props => props.theme.color.primary.getShade(8) || ocean.getShade(8)} 0%,
      ${props => props.theme.color.base.getShade(9) || magic.getShade(9)} 100%
    );
    color: white;
    display: flex;
    flex-direction: column;
    height: 389px;
    justify-content: center;
    margin: 65px 0 80px;
    width: 100%;
    ${styledMedia.small`
    height: 298px;
    margin-bottom: 16px;
    `}
  `,
  Content: styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: visible;
  `,
  Details: styled.div`
    width: 443px;
  `,
  MustReadText: styled.div`
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 24px;
  `,
  BookTitle: styled.div`
    font-size: 4rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 8px;
    ${styledMedia.small`
    font-size: 2.6rem;
  `}
  `,
  Author: styled.div`
    font-size: 2.4rem;
    font-weight: 300;
    margin-bottom: 24px;
    ${styledMedia.small`
    font-size: 2rem;
  `}
  `,
  BookContainer: styled.div`
    width: auto;
    margin-left: 66px;
    max-height: 480px;
    min-height: 420px;
  `
};

const MustRead = ({ asset, openBookPanel, isMedium }) => {
  if (!asset) {
    return null;
  }
  return (
    <Styled.Container key="branded-must-read">
      <Styled.Content>
        <Styled.Details>
          <Styled.MustReadText>
            <Translation id="explore.must-read">
              Recommended for you
            </Translation>
          </Styled.MustReadText>
          <Styled.BookTitle>
            <TextEllipsis toolTipText={asset.title} lines={2}>
              <span>{asset.title}</span>
            </TextEllipsis>
          </Styled.BookTitle>
          <Styled.Author>{asset.author}</Styled.Author>
          <OpenFeaturedBookButton asset={asset} />
        </Styled.Details>
        {!isMedium && (
          <Styled.BookContainer>
            <BookButton
              height="420px"
              asset={asset}
              onClick={openBookPanel}
              forceHeight={true}
              blur={false}
            />
          </Styled.BookContainer>
        )}
      </Styled.Content>
    </Styled.Container>
  );
};

const mapDispatchToProps = (dispatch, props) => ({
  openBookPanel: () =>
    dispatch(
      uiLibraryActions.openSimpleBookPanel(props.asset.vbid, props.asset.title)
    )
});

export default withTheme(connect(null, mapDispatchToProps)(MustRead));
